import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";

const BASE_URL = "https://partyhousedatabase-rpft.onrender.com";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false); // password visibility state

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${BASE_URL}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (res.ok) {
        alert("Login Successful");
        navigate("/admin/bookings"); // redirect to dashboard
      } else {
        alert(data.error || "Login failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error. Please try again.");
    }
  };

  return (
    <div style={container}>
      <h2>Admin Login</h2>

      <form onSubmit={handleSubmit} style={formStyle}>
        <input
          placeholder="Email"
          type="email"
          value={form.email}
          onChange={(e) => handleChange("email", e.target.value)}
          style={input}
          required
        />

        {/* Password Field with Eye Icon */}
        <div style={passwordWrapper}>
          <input
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            value={form.password}
            onChange={(e) => handleChange("password", e.target.value)}
            style={inputWithIcon}
            required
          />
          <span style={eyeIcon} onClick={() => setShowPassword((prev) => !prev)}>
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </span>
        </div>

        <button type="submit" style={button}>
          Login
        </button>
      </form>

      {/* Signup link */}
      <p style={signupText}>
        Don't have an account?{" "}
        <span style={signupLink} onClick={() => navigate("/admin/register")}>
          Sign Up
        </span>
      </p>
    </div>
  );
}

// --- Styles ---
const container = {
  width: "100%",
  maxWidth: "400px",
  margin: "70px auto",
  padding: "30px",
  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
  borderRadius: "10px",
  textAlign: "center",
};

const formStyle = { display: "flex", flexDirection: "column", gap: "15px" };
const input = { padding: "12px", borderRadius: "8px", border: "1px solid #ccc" };
const button = {
  padding: "12px",
  background: "#c59d5f",
  border: "none",
  borderRadius: "8px",
  color: "#fff",
  cursor: "pointer",
};
const signupText = {
  marginTop: "15px",
  fontSize: "0.9rem",
  color: "#555",
};
const signupLink = {
  color: "#c59d5f",
  fontWeight: "600",
  cursor: "pointer",
};

// Password input wrapper for eye icon
const passwordWrapper = {
  position: "relative",
  display: "flex",
  alignItems: "center",
};

// Input with space for icon
const inputWithIcon = {
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  width: "100%",
  paddingRight: "40px", // space for eye icon
};

// Eye icon inside input
const eyeIcon = {
  position: "absolute",
  right: "10px",
  cursor: "pointer",
  fontSize: "18px",
  color: "#555",
};
